export default "__VITE_ASSET__DJS3rjGp__"